import type { DynamicTableColumnConfig, DynamicTableRowConfig } from '../config/types';

export const validateDynamicTableCells = (
  rows: DynamicTableRowConfig[],
  columns: DynamicTableColumnConfig[],
  values: Record<string, string>,
): true | string => {
  for (const row of rows) {
    if (row.enabled === false || row.calculation) continue;
    for (const column of columns) {
      if (column.enabled === false || column.calculation) continue;
      const value = (values[`${row.key}${column.key}`] ?? '').trim();
      if (
        !value &&
        column.requiredUnlessColumn &&
        !(values[`${row.key}${column.requiredUnlessColumn}`] ?? '').trim()
      ) {
        return `Enter ${column.label} for ${row.label}, or explain the missing data in Notes.`;
      }
      if (!value || !column.strictNumeric) continue;
      const decimal = row.allowDecimal === true || column.allowDecimal === true;
      const negative = row.allowNegativeNumbers === true || column.allowNegativeNumbers === true;
      const pattern = new RegExp(`^${negative ? '-?' : ''}\\d+${decimal ? '(\\.\\d+)?' : ''}$`);
      if (!pattern.test(value) || !Number.isFinite(Number(value))) {
        return `Enter ${negative ? '' : 'a non-negative '}${decimal ? 'number' : 'whole number'} for ${row.label}, ${column.label}.`;
      }
    }
  }
  return true;
};
